import { Alert } from '../../components';
export function alertScreen() {
    var alert = new Alert({});
    if (DEVELOPMENT && location.search.includes('alert')) {
        setTimeout(function () { return alert.show(); }, 100);
    }
    return alert;
}
